import {GLTFExporter} from "three/examples/jsm/exporters/GLTFExporter.js";
import {Object3D, Mesh, Material, BackSide, MeshStandardMaterial} from "three";
import {DateUtils} from "./DateUtils";
import {FileUtils} from "./FileUtils";
import {THREEUtils} from "./THREEUtils";

export class SceneExporter
{
	private static _gltfExporter = new GLTFExporter();

	public static export(scene: Object3D)
	{
		const clone = THREEUtils.deepClone(scene);

		clone.traverse((obj: Object3D) =>
		{
			if (obj instanceof Mesh)
			{
				if (obj.material instanceof Material)
				{
					const oldMaterial = obj.material as MeshStandardMaterial;

					obj.material = new MeshStandardMaterial({
						transparent: oldMaterial.transparent,
						opacity: oldMaterial.opacity,
						color: oldMaterial.color,
						map: oldMaterial.map,
						normalMap: oldMaterial.normalMap,
						roughness: 0.75,
						metalness: 0,
						name: oldMaterial.name,
						flatShading: oldMaterial.flatShading
					});

					if (oldMaterial.side === BackSide)
					{
						THREEUtils.flipBufferGeometryNormals(obj.geometry);
					}
				}
			}
		});
		const options = {
			binary: true
		};

		this._gltfExporter.parse(clone, (result: ArrayBuffer) =>
		{
			FileUtils.downloadFileGivenByData(result, `mueller-${DateUtils.getCurrentDateString()}.glb`, "application/octet-stream");
		}, undefined, options);
	};
}